<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title v-if="dataLoaded">
            {{ jurisdiction.canonical_name }}
        </template>
        <slot v-if="dataLoaded">
            <minimum-wage-sidebar-widget
                :jurisdiction="jurisdiction"
                @updated="getData()"
            />

            <unemployment-insurance-program-rate-sidebar-widget
                v-if="jurisdiction.type == 'state'"
                :jurisdiction="jurisdiction"
                @updated="getData()"
            />

            <filing-status-sidebar-widget
                :jurisdiction="jurisdiction"
                @updated="getData()"
            />

        </slot>
    </sidebar>
</template>

<script>
import MinimumWageSidebarWidget from './MinimumWageSidebarWidget'
import UnemploymentInsuranceProgramRateSidebarWidget from './UnemploymentInsuranceProgramRateSidebarWidget.vue'
import FilingStatusSidebarWidget from './FilingStatusSidebarWidget'
import Sidebar from '@/components/Sidebar'

export default {
    components: {Sidebar, MinimumWageSidebarWidget, FilingStatusSidebarWidget, UnemploymentInsuranceProgramRateSidebarWidget, },
    props: ['jurisdictionId', ],
    data() {
        return {
            dataLoaded: false,
            jurisdiction: null,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/jurisdictions/${this.jurisdictionId}`).then(resp => {
                this.jurisdiction = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(this.$bus.firstError(errors))
            })
        },
    },
}
</script>
